import { Serializable } from './serializable';

// 空レスポンス.
export class Empty implements Serializable<Empty> {
  public deserialize(_: any): Empty {
    return this;
  }
}
